var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "studio_icon 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.216 235.289C104.711 237.364 110.099 235.028 112.058 230.46L152.494 136.166L187.303 54.9902C198.397 65.0155 207.307 77.2212 213.354 90.9755C225.057 117.592 225.078 147.827 213.413 175.029C201.748 202.231 179.353 224.172 151.154 236.025C125.778 246.692 97.5727 248.403 71.619 241.031C66.8188 239.668 64.6359 234.53 66.5949 229.962L70.8454 220.05C80.542 225.945 90.8282 230.954 100.216 235.289Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 136",
    d: "M102.534 209.814C100.575 214.382 95.1876 216.718 90.6928 214.643C66.3905 203.42 47.1765 184.164 36.6457 160.212C24.9434 133.596 24.9224 103.361 36.5873 76.1592C48.2522 48.9572 70.6474 27.0162 98.8461 15.163C124.222 4.49636 152.427 2.78517 178.381 10.1568C183.181 11.5202 185.364 16.6576 183.405 21.2259L142.97 115.52L102.534 209.814Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavStudio);
export default __webpack_public_path__ + "static/media/nav-studio.e85461a64b22f46a02c6694863470be0.svg";
export { ForwardRef as ReactComponent };